var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('a',{staticClass:"home-link",attrs:{"href":"https://uni-dubna.ru"}},[_c('img',{attrs:{"src":require("../assets/unilogo.png")}})])])}]

export { render, staticRenderFns }